import type React from "react";
import {ErrorOutline, VisibilityOutlined} from "@mui/icons-material";
import {Tag} from "~/components/tag/Tag.tsx";
import type {Gap} from "../contractExplorerTypes.ts";
import {sortGaps} from "../contractExplorerFormat.ts";
import {Section} from "./Section.tsx";

/** What the bundle is missing: an action gap kept linkage from finishing; a watch gap limits what can be read. */
export const MissingInformation: React.FC<{gaps: Gap[]}> = ({gaps}) => {
    if (!gaps.length) return null;
    const actions = gaps.filter(g => g.severity === 'action').length;
    return (
        <Section
            title={`Missing information (${gaps.length})`}
            sub={actions
                ? `${actions} of these kept linkage from finishing. The rest only limit what can be read from the bundle.`
                : 'None of these kept linkage from finishing; they limit what can be read from the bundle.'}>
            <div className="ci-card ci-gaps">
                {sortGaps(gaps).map(gap => (
                    <div key={gap.key} className={`ci-gap ci-gap--${gap.severity}`}>
                        <span className="ci-gap-ico">
                            {gap.severity === 'action' ? <ErrorOutline fontSize="small"/> : <VisibilityOutlined fontSize="small"/>}
                        </span>
                        <span>
                            <span className="ci-gap-l">{gap.label}</span>
                            <span className="ci-gap-n">{gap.note}</span>
                        </span>
                        {gap.severity === 'action'
                            ? <Tag label="Blocks linkage" color="error"/>
                            : <Tag label="Limits reading" color="default" variant="outlined"/>}
                    </div>
                ))}
            </div>
        </Section>
    );
};
